/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Settings } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { setPrimaryAsColor } from "src/assets/styles/styles";
import DeleteButton from "src/components/atoms/inputs/EwaButtons/DeleteButton";
import { LinkTo } from "src/globalTypes";
import { OverviewTemplateRouteState } from "src/utils/internalLinksParsing";
import {
  FabContainer,
  innerContainerCss,
  labelWrapperCss,
  notificationContainerCss,
  notificationMessageCss,
  NotificationRow,
  NotificationTitle,
} from "../styles";

type Props = {
  title: string;
  label: string;
  link: LinkTo<OverviewTemplateRouteState>;
  handleClick(): void;
  handleDelete(): void;
};

const AdminCardList = ({
  title,
  label,
  link,
  handleClick,
  handleDelete,
}: Props) => (
  <NotificationRow>
    <div css={notificationContainerCss}>
      <Link to={link} onClick={handleClick} css={innerContainerCss}>
        <div css={labelWrapperCss}>
          <NotificationTitle>
            <span data-cy="template-name">{title}</span>
          </NotificationTitle>
          <p css={notificationMessageCss} data-cy="notification-title">
            {label}
          </p>
        </div>
      </Link>
    </div>
    <FabContainer>
      <DeleteButton onClick={handleDelete} />
    </FabContainer>
  </NotificationRow>
);

export default AdminCardList;
